import {optimizationCardSchema} from '../../../../../schemas/optimizationCardSchema';
import {z} from 'zod';
import {
  DTOptimizationNode,
  OptimizationNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {
  OptimizeAcrossName,
  OptimizeAcrossValue,
  OptimizeByName,
  OptimizeByValue,
} from 'common/src/modules/optimization/optimization.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';

export function convertOptimizationAPICardToAICard(
  optimizationCard: DTOptimizationNode,
): z.output<typeof optimizationCardSchema> {
  const candidate: z.input<typeof optimizationCardSchema> = {
    cardId: optimizationCard.id,
    name: optimizationCard.name ?? `Optimization #${optimizationCard.id}`,
    description: optimizationCard.description ?? '',
    type: NodeType.GENERAL_OPTIMIZATION,
    variationsCount: optimizationCard.variationsCount ?? 0,
    configuration: optimizationCard.configuration
      ? {
          optimizeBy:
            getMatchingEnumValue(
              OptimizeByValue,
              OptimizeByName,
              optimizationCard.configuration.optimizeBy,
            ) ?? OptimizeByName.Clicks,
          optimizeGroup:
            getMatchingEnumValue(
              OptimizeAcrossValue,
              OptimizeAcrossName,
              optimizationCard.configuration.optimizeGroup,
            ) ?? OptimizeAcrossName.Campaign,
        }
      : {
          optimizeBy: OptimizeByName.Clicks,
          optimizeGroup: OptimizeAcrossName.Campaign,
        },
    outputs: optimizationCard.outputs.map((output: OptimizationNodeOutputData) => ({
      destinationCardId: output.nodeId ?? 0,
      outputId: output.id,
      name: output.name ?? '',
      type: OutputType.Regular,
    })),
  } satisfies z.output<typeof optimizationCardSchema>;

  return candidate;
}
